import _ from 'lodash';
import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const getAll = () =>
  request({
    baseURL: API.BASE_URL,
    url: API.AGENT_RATE,
    method: 'GET',
  });

const searchByName = searchText =>
  request({
    baseURL: API.BASE_URL,
    url: API.AGENT_RATE,
    method: 'GET',
    params: {
      filter: [
        searchText && {
          type: 'like',
          field: 'name',
          value: `%${searchText}%`,
        },
      ].filter(o => o),
    },
    paramsSerializer: params => qs.stringify(params),
  });

const getOptions = (inputValue, callback) => {
  searchByName(inputValue).then(results => {
    callback(
      _.get(results, 'data._embedded.agent-rate', []).map(item => ({
        value: item.id,
        label: item.name,
      })),
    );
  });
  // eslint-disable-next-line no-useless-return
  return;
};

const AgentRateService = {
  getAll,
  getOptions,
};

export default AgentRateService;
